(function () {
    'use strict';

    angular
        .module('rms.common')
        .constant('FILTER_OPERATOR_CONSTANT', {
            'CONTAINS': 'contains',
            'NOT_CONTAINS': 'not_contains',
            'EQUAL': 'eq',
            'NOT_EQUAL': 'neq',
            'IS': 'is',
            'IN': 'in',
            'NOT_IN': 'not_in',
            'IN_ALL': 'in_all',
            'NOT_IN_ALL': 'not_in_all',
            'LESSER_THAN': 'lt',
            'LESSER_THAN_OR_EQUAL': 'lte',
            'GREATER_THAN': 'gt',
            'GREATER_THAN_OR_EQUAL': 'gte',
            'BETWEEN': 'between',
            'RANGE': 'range',
            'EXISTS': 'exists',
            'NOT_EXISTS': 'not_exists'
        });
})();